import { Pipe, PipeTransform } from '@angular/core';
import { StoreViewModel } from '@models/api.models';

@Pipe({
    name: 'byRegion',
    standalone: true
})
export class ByRegionPipe implements PipeTransform {
    transform(stores: StoreViewModel[], regions: string[] | null): StoreViewModel[] {
        if (!regions?.length) {
            return stores;
        }

        return stores.filter(store => {
            if (store?.region) {
                return regions.map(region => region.toLowerCase()).includes(store.region.toLowerCase());
            }

            return true;
        });
    }
}
